// Editor flow stages — shown as numbered steps in the Configure header.
export const STAGES = [
  { id: 'unit',              label: 'Select Unit*',     icon: '1' },
  { id: 'polygon',           label: 'Set Pin / Boundary', icon: '2' },
  { id: 'compass',           label: 'Apply Compass',    icon: '3' },
  { id: 'space-analysis',    label: 'Space Analysis',   icon: '4' },
  { id: 'entrance-analysis',   label: 'Entrance Analysis',   icon: '5' },
  { id: 'astro-numero',       label: 'Add Birth Date',       icon: '6' },
];
